export type AppRole = 'manager' | 'parent' | 'employee';

export const APP_ROLES: readonly AppRole[] = ['manager', 'parent', 'employee'] as const;

export const ROLE_PORTAL_PATH: Record<AppRole, string> = {
  manager: '/portal/managers',
  parent: '/portal/parents',
  employee: '/portal/employees',
};

type MetadataLike = Record<string, unknown> | null | undefined;

export function parseAppRole(value: unknown): AppRole | null {
  if (typeof value !== 'string') return null;
  const normalized = value.trim().toLowerCase();
  if (normalized === 'managers') return 'manager';
  if (normalized === 'parents') return 'parent';
  if (normalized === 'employees') return 'employee';
  if ((APP_ROLES as readonly string[]).includes(normalized)) {
    return normalized as AppRole;
  }
  return null;
}

/** Reads role from Clerk publicMetadata (preferred) or unsafeMetadata. */
export function getRoleFromMetadata(
  publicMetadata?: MetadataLike,
  unsafeMetadata?: MetadataLike
): AppRole | null {
  return (
    parseAppRole(publicMetadata?.role) ??
    parseAppRole(publicMetadata?.appRole) ??
    parseAppRole(unsafeMetadata?.role) ??
    null
  );
}

export function isClerkConfigured(): boolean {
  return Boolean(import.meta.env.VITE_CLERK_PUBLISHABLE_KEY);
}
